import Step10 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      injuryTypeList: [
        { title: 'ترومای نافذ', id: 1 },
        { title: 'ترومای بلانت', id: 2 },
        { title: 'خونریزی', id: 3 },
        { title: 'پارگی', id: 4 },
        { title: 'جسم خارجی', id: 5 },
        { title: 'تغییر شکل', id: 6 },
        { title: 'له شدگی', id: 7 },
        { title: 'خراشیدگی', id: 8 },
        { title: 'سوراخ شدگی', id: 9 },
        { title: 'سوختگی', id: 10 },
        { title: 'حساسیت به درد', id: 11 },
        { title: 'بریدگی', id: 12 },
        { title: 'تورم', id: 13 },
        { title: 'در رفتگی', id: 14 },
        { title: 'شکستگی', id: 15 },
        { title: 'قطع اندام', id: 16 },
        { title: 'ضایعه حسی', id: 17 },
        { title: 'ضایعه حرکتی', id: 18 },
        { title: 'سایر', id: 19 },
      ],
      selectedPart: null,
      burnDegree: null,
      burnPercentage: null,
      selectedProblems: [],
      allProblems: [],
      isFront: null,
      injuryModal: false,
      injury: new Step10.Step10(null, null, null, []),
      otherFlag: false,
      burnFlag: false,
      otherText: '',
    };
  },
  methods: {
    frontBodyclick: function (part) {
      this.isFront = true;
      this.selectedPart = part;
      this.injuryModal = true;
    },
    backBodyclick: function (part) {
      this.isFront = false;
      this.selectedPart = part;
      this.injuryModal = true;
    },
    selectedItemsChange: function () {
      if (this.selectedProblems.includes('سوختگی')) {
        this.burnFlag = true;
      } else {
        this.burnFlag = false;
      }
      if (this.selectedProblems.includes('سایر')) {
        this.otherFlag = true;
      } else {
        this.otherFlag = false;
      }
    },
    addProblem: function () {
      this.injury.bodyPartId = this.selectedPart;
      this.injury.patientId = this.patientId;
      this.injury.isFront = this.isFront;
      for (let i = 0; i < this.selectedProblems.length; i++) {
        if (this.selectedProblems[i] != 'سایر') {
          this.injury.typeOfInjuries.push({
            typeOfInjury: this.selectedProblems[i],
            burnDegree: Number(this.burnDegree),
            burnPercentage: this.burnPercentage,
          });
        } else {
          if (!this.otherText) {
            this.showErrorAlert('سایر با ذکر نام نمی تواند خالی باشد');
            return;
          }
          if (!this.otherText.replace(/\s/g, '').length) {
            this.showErrorAlert('سایر با ذکر نام نمی تواند خالی باشد');
            return;
          }
          this.injury.typeOfInjuries.push({
            typeOfInjury: this.otherText,
            burnDegree: Number(this.burnDegree),
            burnPercentage: this.burnPercentage,
          });
        }
      }
      this.addPatientBodyExaminationFunction(this.injury);
    },
    patientBodyExaminationAdded: function () {
      this.burnDegree = null;
      this.burnPercentage = null;
      this.selectedProblems = [];
      this.isFront = null;
      this.selectedPart = null;
      this.injury = new Step10.Step10(null, null, null, []);
      this.otherFlag = false;
      this.burnFlag = false;
      this.otherText = '';
      this.burnDegree = null;
      this.injuryModal = false;
      this.getAllPatientBodyExaminationFunction(this.patientId);
    },
    cancelAddProblem: function () {
      if (this.isFront == true) {
        this.$refs.front.clearPart(this.selectedPart);
      } else {
        this.$refs.back.clearPart(this.selectedPart);
      }
      this.burnDegree = null;
      this.burnPercentage = null;
      this.selectedProblems = [];
      this.isFront = null;
      this.selectedPart = null;
      this.otherFlag = false;
      this.burnFlag = false;
      this.otherText = '';
      this.burnDegree = null;
      this.injuryModal = false;
      this.getAllPatientBodyExaminationFunction(this.patientId);
    },
    setData: function (data) {
      this.allProblems = [];
      for (let i = 0; i < data.length; i++) {
        let isFront = '';
        if (data[i].isFront == true) {
          isFront = 'جلو';
        } else if (data[i].isFront == false) {
          isFront = 'پشت';
        }
        this.allProblems.push({
          bodyPartId: data[i].bodyPartId,
          isFront: isFront,
          typeOfInjury: data[i].typeOfInjury,
          burnDegree: data[i].burnDegree,
          id: data[i].id,
        });
        if (data[i].isFront == true) {
          this.$refs.front.colorPart(data[i].bodyPartId);
        } else {
          this.$refs.back.colorPart(data[i].bodyPartId);
        }
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab3Step(3, true);
    },
    backToStep9: function () {
      this.$root.$refs.FollowUpPatient.changeTab3Step(1, true);
    },
  },
};
